
import {
  CLEAN_MESSAGES,
  SET_UPLOAD_ERROR,
  SET_UPLOAD_SUCCESS,
} from './types';

export const clearMessages = () => async dispatch => dispatch({ type: CLEAN_MESSAGES });

export const clearFileUploadError = () => async dispatch => dispatch({
  type: SET_UPLOAD_ERROR, payload: '',
});


export const setSuccessToastMessage = message => async dispatch => dispatch({
  type: SET_UPLOAD_SUCCESS,
  payload: message,
});
